// Collapsible "More" fold for the boxes used less than half the time (SWEEP-
// SCOPE §6 "The optional fold", §7 rule 8): Notes, fees, cost splits,
// references, return legs. Keeps minimalist screens minimalist; the operator
// opts in to expand. The fold is called "More" everywhere — a screen passes a
// label only when the fold holds one named thing.

import { useState } from 'react';
import { displayAsset } from '../lib/format';
import { ChevronDown, ChevronRight } from 'lucide-react';

export function MoreDetails({
  label = 'More',
  defaultOpen = false,
  children,
}: {
  label?: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="tap-44 btn-link text-meta flex items-center gap-1 py-1"
      >
        {open ? <ChevronDown size={12} /> : <ChevronRight size={12} />}
        {label}
      </button>
      {open && <div className="mt-2 space-y-2 pl-3 border-l border-tg-secondary">{children}</div>}
    </div>
  );
}

/** Compact `[amount input] [asset select]` row used across Book Trade + workflow forms. */
export function AmountAssetRow({
  amount,
  asset,
  onAmount,
  onAsset,
  assets,
  placeholder = '0',
}: {
  amount: string;
  asset: string;
  onAmount: (v: string) => void;
  onAsset: (v: string) => void;
  assets: readonly string[];
  placeholder?: string;
}) {
  return (
    <div className="flex gap-2">
      <input
        className="input flex-1"
        value={amount}
        onChange={(e) => onAmount(e.target.value)}
        placeholder={placeholder}
        inputMode="decimal"
      />
      <select
        className="select w-24 shrink-0"
        value={asset}
        onChange={(e) => onAsset(e.target.value)}
      >
        {assets.map((a) => <option key={a} value={a}>{displayAsset(a)}</option>)}
      </select>
    </div>
  );
}
